import { HttpErrorResponse } from '@angular/common/http';

/** The failure of a traced request, still an `HttpErrorResponse` for every existing consumer. */
export class TracedHttpErrorResponse extends HttpErrorResponse {
  constructor(
    original: HttpErrorResponse,
    public readonly traceparent: string,
  ) {
    super({
      error: original.error,
      headers: original.headers,
      status: original.status,
      statusText: original.statusText,
      url: original.url ?? undefined,
    });
  }
}

export function traceparentOf(error: unknown): string | undefined {
  return error instanceof TracedHttpErrorResponse ? error.traceparent : undefined;
}
